
/**
 * Created by libaiqi on 2018/10/24.
 */
import Logic from '../logic-base'

const securityRoleBiz = new Logic()

securityRoleBiz.addRole = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.securityRole.addRole,
    data: data
  })
}

securityRoleBiz.findByPage = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.securityRole.findByPage,
    data: data
  })
}

securityRoleBiz.deleteRole = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.securityRole.deleteRole,
    data: data
  })
}

export default securityRoleBiz
